import { Component, Input, OnInit } from "@angular/core";
import { BehaviorSubject, combineLatest, map, mergeMap, tap, Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";

import { SearchParametersModel } from "../../models/search-parameters.model";
import { PagedListModel } from "../../../../../shared-library/models/paged-list.model";
import { RecommendedLinkModel } from "./recommended-link.model";

import { SearchParamsModel } from "./search-parameters.model";

@Component({
    selector: "pcg-ng-recommended-links",
    templateUrl: "recommended-links.component.html"
})
export class RecommendedLinksComponent implements OnInit {
    @Input() public searchParameters$: Observable<SearchParametersModel>;

    public recommendedLinksParameters$: Observable<SearchParamsModel>;
    public recommendedLinks$: Observable<PagedListModel<RecommendedLinkModel>>;
    public pageSize$ = new BehaviorSubject(7);

    public constructor(private _http: HttpClient) {
    }

    public ngOnInit(): void {
        this.recommendedLinksParameters$ = combineLatest([this.searchParameters$, this.pageSize$]).pipe(
            map(([p, pageSize]) => {
                return {
                    searchText: p.searchText,
                    pageNumber: 1,
                    pageSize: pageSize
                };
            })
        );

        this.recommendedLinks$ = this.recommendedLinksParameters$.pipe(
            map(p => new HttpParams({fromObject: p})),
            mergeMap(p => this._http.get<PagedListModel<RecommendedLinkModel>>("/umbraco/api/recommended-links-search/search/", {params: p}))
        );
    }

    public showAll(e: Event, totalItems: number): void {
        e.preventDefault();

        this.pageSize$.next(totalItems);
    }
}
